import fabric from '../../common/fabric/index';
// TODO: migrate once and for all in undoable reducer
import { migrateSlideContent } from '../../common/migrations';
import localForage from 'localforage';
import { MODE_TEMPLATE } from '../../common/lib/modes';
import SparkMD5 from 'spark-md5';

let thumbQueue = null;
const thumbCanvases = {};

const generateThumbnailImage = (getState, slideId, fabricCanvas, dispatch) =>
  new Promise(resolve => {
    const presentation = getState().presentationReducer;

    const presentationContent = getState().contentReducer.presentation;
    let slide = presentationContent.slides[slideId];
    if (presentationContent.mode === MODE_TEMPLATE) {
      slide = presentationContent.editingTheme.templates[slideId];
    }

    const jsonString = JSON.stringify(migrateSlideContent(slide.content));
    localForage.getItem(slideId, (error, data) => {
      if (error) {
        console.warn(error);
        localForage.setItem(slideId, null);
      }
      if (
        !error &&
        data &&
        data.imageData &&
        data.version === SparkMD5.hash(jsonString)
      ) {
        resolve(data.imageData);
        return true;
      }
      if (!thumbCanvases[slide.id]) {
        const thumbHeight = 310;
        const ratio = thumbHeight / presentation.documentSize.height;
        const thumbWidth = Math.ceil(presentation.documentSize.width * ratio);
        const thumbCanvas = new fabric.StaticCanvas(slide.id, {
          width: thumbWidth,
          height: thumbHeight,
        });
        thumbCanvas.renderOnAddRemove = true;
        thumbCanvas.enableRetinaScaling = false;
        thumbCanvas.setZoom(ratio);
        thumbCanvases[slide.id] = thumbCanvas;
      }

      const thumbCanvas = thumbCanvases[slide.id];
      if (!getState().fontsReducer.loaded) {
        setTimeout(() => {
          dispatch(generateSlideThumbnail(slideId));
        }, 500);
        return resolve(null);
      }
      if (slide) {
        // let's use the actual canvas to generate thumbnail after a user modfiication.
        // ludusCharts are async and we must use json method to render them correctly

        const jsonString = JSON.stringify(migrateSlideContent(slide.content));
        thumbCanvas.loadFromJSON(jsonString, () => {
          thumbCanvas.asyncToDataURL(
            data => {
              resolve(data);
              localForage.setItem(slideId, {
                version: SparkMD5.hash(jsonString),
                imageData: data,
              });
              thumbCanvas.forEachObject(o => o.dispose?.());
            },
            {
              format: 'jpg',
              multiplier: 1,
              quality: 0.85,
            },
          );
        });
      } else {
        resolve(null);
      }
    });
  }).catch(() => {
    // ignore error it's probably switching mode while generating thumbs
  });

class ThumbQueue {
  constructor(dispatch, getState, fabricCanvas) {
    this.dispatch = dispatch;
    this.getState = getState;
    this.fabricCanvas = fabricCanvas;
    this.running = false;
  }

  add(slideId) {
    const presentation = this.getState().contentReducer.presentation;
    let slide = presentation.slides[slideId];
    if (presentation.mode === 'template') {
      slide = presentation.editingTheme.templates[slideId];
    }
    if (slide) {
      // Inform the thumbnail reducer that this thumbnail is about to be generated
      this.dispatch({ type: 'THUMBNAIL_GENERATING', id: slideId });
      this.run();
    }
  }

  run() {
    // if (!this.getState().fontsReducer.loaded) {
    //   setTimeout(() => this.run(), 500);
    //   return;
    // }
    if (this.running) {
      return;
    }
    if (this.getState().thumbnailsReducer.generating.length === 0) {
      return;
    }

    // Then, build a list of promise-returning functions that we will pass to `utils.promiseSerial`
    const slideIds = this.getState().thumbnailsReducer.generating;
    const thumbnailPromiseFactories = slideIds.slice(0, 5).map(
      slideId =>
        new Promise(resolve => {
          generateThumbnailImage(
            this.getState,
            slideId,
            this.fabricCanvas,
            this.dispatch,
          )
            .then(imageData => {
              this.dispatch({
                type: 'THUMBNAIL_GENERATED',
                id: slideId,
                imageData,
              });
              resolve();
            })
            .catch(() => {
              resolve();
            });
        }),
    );
    Promise.all(thumbnailPromiseFactories).then(() => {
      this.running = false;
      this.run();
    });
    this.running = true;
  }
}

export const generateSlideThumbnail = slideId => (
  dispatch,
  getState,
  fabricCanvas,
) => {
  if (thumbQueue === null) {
    thumbQueue = new ThumbQueue(dispatch, getState, fabricCanvas);
  }
  thumbQueue.add(slideId);
};
